angular.module('app.financeiro').factory('parametroBancoFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'ParametroBanco';

    var _list = function (search, options) {
        var dto = options.data;
        dto.search = search;
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _save = function (isNew, dto) {
        var method = isNew ? 'Insert' : 'Update';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    };

    var _delete = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Remove', dto);
    };

    var _listAll = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAll');
    };

    var _listAllLayouts = function (options) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllLayouts').then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listClientId = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListClientId');
    };

    var _getParamBancoParaCarteiraBoleto = function (codigoAgendaPagamento) {
        var dto = {};
        dto.id = codigoAgendaPagamento;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/GetParamBancoParaCarteiraBoleto', dto);
    };

    var _getParamBancoParaCarteiraAntecipacao = function (codigoAgendaPagamento) {
        var dto = {};
        dto.id = codigoAgendaPagamento;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/GetParamBancoParaCarteiraAntecipacao', dto);
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.findRecord = _findRecord;
    factory.list = _list;
    factory.save = _save;
    factory.delete = _delete;
    factory.listAll = _listAll;
    factory.listAllLayouts = _listAllLayouts;
    factory.listClientId = _listClientId;
    factory.getParamBancoParaCarteiraBoleto = _getParamBancoParaCarteiraBoleto;
    factory.getParamBancoParaCarteiraAntecipacao = _getParamBancoParaCarteiraAntecipacao;

    return factory;

}]);
